// extracted by mini-css-extract-plugin
export var calculatedBadge = "_ww-8";
export var container = "_ww-0";
export var radioDot = "_ww-5";
export var radioDotSelected = "_ww-6";
export var row = "_ww-1";
export var rowFirst = "_ww-2";
export var rowLast = "_ww-3";
export var rowSelected = "_ww-4";
export var strikethrough = "_ww-7";